import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { palette } from 'util/style-helpers';

export const style: any = (styles: IGenericObject) => {
  return StyleSheet.create({
    channelHeaderContainer: {
      display: 'flex',
      flexDirection: 'column',
      background: palette.white,
      borderBottom: `1px solid ${palette.lighterGrey}`,
    },
    channelHeaderHeading: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      margin: '0px 20px 5px',
      height: 60,
    },
    channelHeaderText: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginLeft: 20,
    },
    channelHeaderName: {
      fontWeight: 500,
      fontSize: 18,
      color: palette.black,
      marginBottom: 5,
    },
    channelHeaderSubtitle: {
      color: palette.black,
      fontSize: 12,
      margin: 0,
    },
  });
};
